/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useSelector, useDispatch } from 'react-redux';
import {
  getReportPreviewPropsSelector,
  setReportPreviewProps,
} from 'features/analyses/libraryItemsSlice';
import { getEntityType } from 'features/comments/commentsSlice';
import { useLocation, useParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { EntityType, LiveReportPreviewProps } from './types';
import { AnalysisLiveReportPreview } from './analysis';
import { StructuredAnalysisLiveReportPreview } from './structured-analysis';
import { KFALiveReportPreview } from './kfa';
import { POTopicsLiveReportPreview } from './potopics';

const Components: Record<
  EntityType,
  (props: LiveReportPreviewProps) => JSX.Element | null
> = {
  analysis: AnalysisLiveReportPreview,
  hypothesis: KFALiveReportPreview,
  'po-topics': POTopicsLiveReportPreview,
  'quality-of-earnings': StructuredAnalysisLiveReportPreview,
  'net-working-capital': StructuredAnalysisLiveReportPreview,
  'debt-debt-like': StructuredAnalysisLiveReportPreview,
};

const LiveReportPreview = () => {
  const dispatch = useDispatch();
  const entityType = useSelector(getEntityType) as EntityType;
  const reportData = useSelector(getReportPreviewPropsSelector);
  const location = useLocation();
  const isEditMode = location.pathname.includes('edit');

  const { projectId } = useParams<{
    projectId: string;
  }>();

  const Component = useMemo(() => Components[entityType], [entityType]);

  const handleReportUpdate = useCallback(
    (payload: unknown) => {
      dispatch(
        setReportPreviewProps(
          payload || {
            isDirty: false,
          }
        )
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const { currentData, territoryName, isDirty, projectName = '' } = reportData;
  const liveReportPreviewProps = useMemo(() => {
    return {
      isEditMode,
      projectId,
      projectName,
      currentData,
      territoryName,
      isDirty,
      entityType,
      handleReportUpdate,
    };
  }, [
    isEditMode,
    projectId,
    projectName,
    currentData,
    territoryName,
    isDirty,
    entityType,
    handleReportUpdate,
  ]);
  return <Component {...liveReportPreviewProps} />;
};

export default LiveReportPreview;
